module.exports = __webpack_public_path__ + "img/lucas-mccallum-portrait-3.89987289.jpg";